const verified = {
  verifiying: 'Confirmation',
  verifiying_account: 'Nous confirmons votre compte!',
  wait: 'SVP patienter pendant que nous confirmons votre compte, vous allez être automatiquement redirigé lorsque c\'est fait',
};

export default verified;
